import { Text, View } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { Chip } from "@visioni/a3s-ui/components";
import type { RoadSenseReportMeta } from "@visioni/a3s-reports/client-messages";

interface RoadSenseHeroProps {
  meta: RoadSenseReportMeta;
  /** The site the report covers (`payload.site.site_title`), shown as the heading. */
  siteTitle: string;
  /** The hire is still running, so the window ends today; adds a Live tag. */
  isLive: boolean;
}

/**
 * Top-of-report header block for RoadSense. RoadSense-owned (a sibling of, not
 * a fork of, the WasteSense hero). The window label comes pre-formatted from the
 * generator (`report_meta`) so the same string appears in the static export.
 */
export function RoadSenseHero({ meta, siteTitle, isLive }: RoadSenseHeroProps) {
  const { theme } = useUnistyles();
  return (
    <View gap="xs" alignItems="flex-start">
      <Text textStyle="xs/semibold" style={{ color: theme.colors.red[600] }}>
        {meta.report_title}
      </Text>
      <Text textStyle="h3" fontSize={22} color="text">
        {siteTitle}
      </Text>
      <View flexDirection="row" alignItems="center" gap="sm">
        <Text textStyle="sm/regular" color="textMuted">
          Reporting window: {meta.window_label}
        </Text>
        {isLive ?
          <Chip label="Live" variant="outlined" />
        : null}
      </View>
    </View>
  );
}
